import React from 'react'

import { bemJoin } from 'bem-join'
import { Stack } from 'component-library-next'

import { FormattedDate, useIntl } from '@app/intl/Intl'
import { FormattedAddress } from '@app/modules/PrintView/Components/FormattedAddress/FormattedAddress'
import { LabelledValue } from '@app/modules/PrintView/Components/LabelledValue/LabelledValue'

import './ContactDetails.scss'

export type Props = {
  contactDetails: {
    dateOfBirth?: Date
    email?: string
    firstName?: string
    lastName?: string
    phone?: string
    address?: {
      street?: string
      city?: string
      zip?: string
      country?: string
    }
    membership?: {
      displayName?: string
      memberSince?: string
    }
  }
}

const b = bemJoin('contact-details')

export const ContactDetails = ({
  contactDetails: { dateOfBirth, email, firstName, lastName, phone, address, membership }
}: Props) => {
  const { formatMessage } = useIntl()

  return (
    <div className={b('container')}>
      <Stack>
        <div>
          <h2 className={b('title')}>{formatMessage({ id: 'PrintView.ContactDetails.Title' })}</h2>
          {(firstName || lastName) && (
            <div>
              {firstName || ''} {lastName || ''}
            </div>
          )}
          {dateOfBirth && <div>{dateOfBirth}</div>}
          {email && <div>{email}</div>}
          {phone && <div>{phone}</div>}
          {address && <FormattedAddress address={address} />}
        </div>
        <div>
          {membership?.displayName && (
            <LabelledValue
              label={formatMessage({ id: 'PrintView.ContactDetails.MembershipName' })}
              value={membership.displayName}
            />
          )}
          {membership?.memberSince && (
            <LabelledValue
              label={formatMessage({ id: 'PrintView.ContactDetails.MemberSince' })}
              value={<FormattedDate value={membership.memberSince} />}
            />
          )}
        </div>
      </Stack>
    </div>
  )
}
